/* @flow */
import * as React from 'react';
import type { TFunction } from 'react-i18next';
import type { ImportRowError } from 'api/brandsBulkImport';
import styles from './ImportShared.module.scss';

type TypeProps = {
  errors: ImportRowError[],
  variant: 'error' | 'warning',
  t: TFunction,
};

const ImportErrorReport = ({ errors, variant, t }: TypeProps): React.Node => {
  if (!errors || errors.length === 0) {
    return null;
  }

  return (
    <div
      className={`${styles['import-error-report']} ${styles[`import-error-report--${variant}`]}`}
    >
      <table className={styles['import-error-report__table']}>
        <thead>
          <tr>
            <th className={styles['import-error-report__header']} scope="col">
              {t('general:reporting.brand_form.multiple.labels.row')}
            </th>
            <th className={styles['import-error-report__header']} scope="col">
              {t('general:reporting.brand_form.multiple.labels.error_message')}
            </th>
          </tr>
        </thead>
        <tbody>
          {errors.map((error: ImportRowError) => (
            <tr
              key={`${error.row}-${error.field}-${error.message}`}
              className={styles['import-error-report__row']}
            >
              <td className={styles['import-error-report__row-number']}>
                {t('general:reporting.brand_form.multiple.labels.row_number', {
                  row: error.row,
                })}
              </td>
              <td className={styles['import-error-report__cell']}>{error.message}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ImportErrorReport;
